import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface UserProfile {
  empId: number;
  empNo: string;
  name: string;
  tenantId?: number;
  tenantSlug?: string;
  avatar?: string;
  deptPath?: string;
  roles: string[];
}

interface AuthState {
  token: string | null;
  profile: UserProfile | null;
  tenantId: number | null;
  tenantSlug: string | null;
  setAuth: (token: string, profile: UserProfile) => void;
  /**
   * 仅刷新 profile（保留 token）。
   * 用于启动时/可见性恢复时拉取 /auth/me 同步最新角色——避免出现「HR 在后台
   * 给某领导新增了表彰提名指派，但该领导本地 localStorage 里还是旧 profile，
   * 一直看不到新菜单」的问题（2026-05-12 秦艳芳事故）。
   */
  refreshProfile: (profile: UserProfile) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      profile: null,
      tenantId: null,
      tenantSlug: null,
      setAuth: (token, profile) =>
        set({
          token,
          profile,
          tenantId: profile.tenantId ?? null,
          tenantSlug: profile.tenantSlug ?? null,
        }),
      refreshProfile: (profile) =>
        set({
          profile,
          tenantId: profile.tenantId ?? null,
          tenantSlug: profile.tenantSlug ?? null,
        }),
      clear: () => set({ token: null, profile: null, tenantId: null, tenantSlug: null }),
    }),
    { name: 'tg-auth' },
  ),
);
